<div class="mat-dialog-header">
  <h1 mat-dialog-title>
    <span>{{ 'agent:popin.transfer_appointments.title' | translate }}</span>
  </h1>
  <div class="actions-container">
    <button mat-icon-button class="close-button" (click)="cancel()">
      <span class="nodisplay">
        {{ 'commons:basic.closePopup' | translate }}"{{ 'agent:popin.transfer_appointments.title' | translate }}"
      </span>
    </button>
  </div>
</div>

<ng-container
  *ngIf="{
    appointment: appointment$ | async,
    availableSkills: availableSkills$ | async,
    availableCsr: availableCsr$ | async,
    availableTeams: availableTeams$ | async,
    availableGroups: availableGroups$ | async
  } as data"
>
  <mat-dialog-content>
    <form [formGroup]="formDialog">
      <cng-appointment-target-form
        (eventTargetChange)="onTargetSelected($event)"
        (eventUpdateCandidateCsr)="updateCandidateCsr($event)"
        [skills]="data.availableSkills"
        [teams]="data.availableTeams"
        [csrs]="data.availableCsr"
        [groups]="data.availableGroups"
        [justSkills]="false"
        [multipleCsrEnabled]="false"
      >
      </cng-appointment-target-form>

      <!-- COMMENTS -->
      <mat-form-field>
        <textarea
          matInput
          cdkTextareaAutosize
          cdkAutosizeMinRows="2"
          cdkAutosizeMaxRows="5"
          formControlName="comment"
          maxlength="255"
        ></textarea>
        <mat-label>{{ 'agent:popin.create_appointment.comment' | translate }}</mat-label>
      </mat-form-field>
    </form>
  </mat-dialog-content>
</ng-container>

<mat-dialog-actions>
  <button mat-button [disabled]="!isFormValid" (click)="submitForm()" class="button-confirm cng-ico_check">
    {{ 'agent:actions.validate' | translate }}
    <span class="nodisplay">
      {{ 'agent:popin.create_appointment.making_appointment' | translate }}
    </span>
  </button>
  <button mat-button (click)="cancel()" class="button-cancel cng-ico_annuler">
    {{ 'agent:actions.cancel' | translate }}
    <span class="nodisplay">
      {{ 'agent:popin.create_appointment.making_appointment' | translate }}
    </span>
  </button>
</mat-dialog-actions>
